// extracted by mini-css-extract-plugin
export default {"icon":"Breadcrumbs-module__[local]___VASSI"};